import Axios from 'axios';
import IdentityProxy from './IdentityProxy';
import RegistrosProxi from './RegistrosProxi'
import DistributivoProxi  from './distributivoProxi';
import MatriculasProxi from './MatriculasProxi';
import HorariosProxi from './horariosProxi';
import AulasProxi from './aulasProxi';
import ActividadProxi from './actividadProxi';
import LogsProxi from './logsProxi';
import NotasProxi from './notasProxi';
import ReportesProxi from './reportesProxi';
import estadisticaProxi from './estadisticaProxi';

// Axios default behavior
Axios.defaults.headers.common.Accept='application/json'

// Token
Axios.interceptors.request.use(
    config => {
        let token = localStorage.getItem('access_token');
        if(token){
            config.headers= {
                'x-access-token': `${token}`
            }
        }
        return config;
    },
    error => Promise.reject(error)
);

Axios.interceptors.response.use(
    response => response,
    error => {
      if (!error.response) {
       alert('Espere un momento por favor, ocurrió algo que no esperado')
      }
      else if(error.response.status===403||error.response.status===401||error.response.status===405) {
        const theme = localStorage.getItem('theme');
        localStorage.clear();
        localStorage.setItem("theme", theme);
        window.location.reload(true);
      }
      
      return Promise.reject(error);
    }
  );

let url = 'https://ucam.uelibertad.online/api'; //  http://localhost:3000/api  https://uecam.online/  http://192.168.68.106:3000/
/*PARA LA SEGUNDA VERSION 
ingresamos esto a cpnsole*/

export default {
    identityProxy: new IdentityProxy(Axios, url),
    _registroProxi : new RegistrosProxi(Axios, url),
    _distributivoProxi : new DistributivoProxi(Axios, url),
    _matriculasProxi : new MatriculasProxi(Axios, url),
    _horariosProxi : new HorariosProxi(Axios, url),
    _aulasProxi: new AulasProxi(Axios, url),
    _actividadProxi: new ActividadProxi(Axios, url),
    _logsProxi: new LogsProxi(Axios, url),
    _notasProxi: new NotasProxi(Axios, url),
    _reportesProxi: new ReportesProxi(Axios, url),
    _estadistProxi: new estadisticaProxi(Axios, url),
}